import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {
  InputNumberWrapper,
  InputTextWrapper,
  SelectWrapper,
} from '../../../../../../components/UI/Form/Input'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {useCamp, useClient, useCompany, useSite} from '../../../../../central/hooks'
import {TITLE_FORM_MANAGEMENT_SEQUENTIAL} from '../../../../util/Constants'
import useTableForMaster from '../../../../hooks/useTableForMaster'
const ManagementSequential: FC = () => {
  const {setValue, setError, watch} = useFormContext()
  const [typeCode, setTypeCode] = useState<string>('')
  const {currentTabItem} = useLavanderia()
  const {siteList, getSiteList, handleClear: handleClearSite} = useSite()
  const {clientList, getClientList, handleClear: handleClearClient} = useClient()
  const {companyList, getCompanyList, handleClear: handleClearCompany} = useCompany()
  const {campList, getCampList, handleClear: handleClearCamp} = useCamp()
  const {typeCodesSequence, getCodesSequencenList} = useTableForMaster()
  useEffect(() => {
    getCompanyList()
    getCodesSequencenList()
  }, [])

  useEffect(() => {
    if (companyList.length === 1) {
      let value = companyList[0].value
      setValue('companiaId', value)
      setError('companiaId', {})
      getClientList({companiaId: value})
    }
  }, [companyList])

  const handleGetClientList = async (val: any) => {
    let value = val ? val.value : ''
    setValue('clienteId', '')
    setError('clienteId', {})
    setValue('siteId', '')
    setError('siteId', {})
    setValue('campamentoId', '')
    setError('campamentoId', {})
    handleClearClient()
    handleClearSite()
    handleClearCamp()
    getClientList({companiaId: value})
  }
  const handleGetSiteList = async (val: any) => {
    let value = val ? val.value : ''
    setValue('siteId', '')
    setError('siteId', {})
    setValue('campamentoId', '')
    setError('campamentoId', {})
    handleClearSite()
    handleClearCamp()
    getSiteList({clienteId: value})
  }

  const handleGetCampList = async (val: any) => {
    let value = val ? val.value : ''
    setValue('campamentoId', '')
    setError('campamentoId', {})
    handleClearCamp()
    getCampList({siteId: value})
  }

  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_MANAGEMENT_SEQUENTIAL}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={companyList}
            onChangeValue={handleGetClientList}
            required
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clientList}
            onChangeValue={handleGetSiteList}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='siteId'
            data={siteList}
            onChangeValue={handleGetCampList}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Campamento'
            name='campamentoId'
            data={[{value: '0', label: 'TODOS'}, ...campList]}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de Código'
            name='tipoCodigoId'
            data={typeCodesSequence}
            onChangeValue={(e) => {
              setTypeCode(e.codigo)
              setValue('cantidad', '')
              setError('cantidad', {})
              setValue('prefijo', '')
              setError('prefijo', {})
            }}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Prefijo'
            name='prefijo'
            textPlaceholder='Escribe el prefijo'
            maxLength={typeCode === '02' ? 2 : 1000}
            type={typeCode === '02' ? 'text' : 'alphaNumeric'}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Cantidad de correlativos'
            name='cantidad'
            maxLength={typeCode === '02' ? 2 : 9999}
            textPlaceholder='Escribe la cantidad de correlativos'
            required
          />
        </div>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </div>
    </ContentForm>
  )
}

export default ManagementSequential
